import http from '@/api/request'

// 资讯信息分页
export function articlePage (data = {}) {
  return http().post('/resource/api/article/page', data)
}

// 资讯分类列表
export function articleCategory () {
  return http().get('/base/api/shop/category/article/list')
}

// 资讯信息详情
export function articleView (data) {
  return http().post('/resource/api/article/view', data)
}

// 资讯广告
export function articleAdvList (data) {
  return http().post('/resource/api/article/adv/list', data)
}

// 热门资讯
export function articleHot (data) {
  return http().post('/resource/api/article/hot/list', data)
}

export function articleRecommend (data) {
  return http().post('/resource/api/article/relevant/recommend/list', data)
}

// 资讯信息搜索
export function articleSearch (data) {
  return http().post('/resource/api/article/search', data)
}
